import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedAsset:[],
  selectedSource:[],
  selectedDate:[],
  selectedSharedUid: null,
  selectedSite: null,
  manualExpenseData: [],
  filteredManualExpense: [],
  singleExpenseData: [],
  allTrafficSources: [],
  currencies: [],
  siteOptions: [],
  selectedManualExpenseShareuid: null,
  page: 0,
  rowsPerPage: 10,
  sort: {
    keytoSort: 'modified',
    direction: 'desc',
  },
  selectedManualExpense: null,
};

const manualExpenseSlice = createSlice({
  name: "manualExpense",
  initialState: initialState,
  reducers: {
    setSelectedAsset: (state, action) => {
      state.selectedAsset = action.payload;
    },
    setSelectedSource: (state, action) => {
      state.selectedSource = action.payload;
    },
    setSelectedDate: (state, action) => {
      state.selectedDate = action.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setSelectedSharedUid: (state, action) => {
      state.selectedSharedUid = action.payload;
    },
    setManualExpenseData: (state, action) => {
      state.manualExpenseData = action.payload;
    },
    setFilteredManualExpense: (state, action) => {
      state.filteredManualExpense = action.payload;
    },
    setSingleExpenseData: (state, action) => {
      state.singleExpenseData = action.payload;
    },
    setAllTrafficSources: (state, action) => {
      state.allTrafficSources = action.payload;
    },
    setCurrencies: (state, action) => {
      state.currencies = action.payload;
    },
    setSiteOptions: (state, action) => {
      state.siteOptions = action.payload;
    },
    setSelectedTemplateShareuid: (state, action) => {
      state.selectedManualExpenseShareuid = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setSelectedManualExpense: (state, action) => {
      state.selectedManualExpense = action.payload;
    },
  },
});

export const {
  setSelectedAsset,
  setSelectedSource,
  setSelectedDate,
  setSelectedSharedUid,
  setSelectedSite,
  setManualExpenseData,
  setFilteredManualExpense,
  setSingleExpenseData,
  setAllTrafficSources,
  setCurrencies,
  setSiteOptions,
  setSelectedTemplateShareuid,
  setPage,
  setRowsPerPage,
  setSort,
  setSelectedManualExpense,
} = manualExpenseSlice.actions;
export default manualExpenseSlice.reducer;
